var exports = {
  "k": "DisableInvitesButton.module__container___UGlaOV",
  "i": "DisableInvitesButton.module__message___UGlaOV",
};

module.exports = exports;
